import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ButtonToggle from '@/design-system/atoms/buttons/ButtonToggle.vue'
import { computed, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

type Emits = {
  (e: 'toggleShowOnMap'): void
}

type Props = {
  active: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowOnMapButton',
  props: {
    active: { type: Boolean }
  },
  emits: ["toggleShowOnMap"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const { active } = toRefs(props)

const { t } = useI18n()

const emit = __emit

const text = computed(() => {
  return active.value ? t('dashboard__text__hide-on-map') : t('dashboard__text__show-on-map')
})

function toggleShowOnMap() {
  emit('toggleShowOnMap')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonToggle, {
    class: "button-toggle",
    buttonText: text.value,
    iconLeft: require('@/design-system/assets/icons/Icon-Eye-Small.svg'),
    size: 'extra-small',
    active: _unref(active),
    onOnClicked: toggleShowOnMap
  }, null, 8, ["buttonText", "iconLeft", "active"]))
}
}

})